import http from "@utils/request";


// 测试数据库
export const updatePassword = (username,oldpassword,newpassword) => http({
  method: "GET",
  url: "/user/updatePassword",
  data:{
    username,oldpassword,newpassword
  }
});
